import React from "react";
import "../../styles/Settings.css";
import { TextHeader } from "../../components/text-header/TextHeader";
import useTranslation from "../../../../hooks/i18n/useTranslation";
import { KeyParameterSelector } from "../../components/key-parameter-selector/KeyParameterSelector";

export const SpinoPelvic = () => {
  const { t } = useTranslation();

  return (
    <aside className="settings-container-aside">
      <TextHeader title={t("277")} content={t("278")} />
      <KeyParameterSelector />
    </aside>
  );
};
